module.exports = __webpack_public_path__ + "static/media/marketing_laptop_light.3199b106.png";